import { render } from "./FullFramePageContainer.vue?vue&type=template&id=6dc6e970&scoped=true"
import script from "./FullFramePageContainer.vue?vue&type=script&lang=js"
export * from "./FullFramePageContainer.vue?vue&type=script&lang=js"

import "./FullFramePageContainer.vue?vue&type=style&index=0&id=6dc6e970&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc6e970"]])

export default __exports__